import { IUser } from '@scentregroup/shared/types/user'
import { createContext, useContext } from 'react'

export interface IUserContextType {
  user?: IUser
  loading: boolean
}

const initialContext: IUserContextType = {
  user: undefined,
  loading: false,
}

export const UserContext = createContext(initialContext)
const useUser = (): IUserContextType => useContext(UserContext)

export default useUser
